import './assets/global.css'
import App from './App.svelte'
import config from './config.js'

// Initialize Google Analytics 4 if measurement ID is provided
if (config.ga4MeasurementId && typeof window !== 'undefined') {
  const script1 = document.createElement('script');
  script1.async = true;
  script1.src = `https://www.googletagmanager.com/gtag/js?id=${config.ga4MeasurementId}`;
  document.head.appendChild(script1);
  
  window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  window.gtag = gtag;
  gtag('js', new Date());
  gtag('config', config.ga4MeasurementId);
}

const app = new App({
  target: document.getElementById('app'),
})

export default app
